import React from 'react';
import Icon from 'presentation/icons';
import {AccordionDetails, Typography} from '@mui/material';
import {AccordionStyled, AccordionSummaryStyled} from './styles';
import {ChannelAccordionProps} from './types';

export function ChannelAccordion({
	title,
	handleAccordionToggle,
	expandedState,
	children,
	dataTagId,
}: ChannelAccordionProps) {
	return (
		<AccordionStyled
			expanded={expandedState === title}
			onChange={handleAccordionToggle(title)}
			data-tag-id={dataTagId}
			slotProps={{transition: {unmountOnExit: true}}}>
			<AccordionSummaryStyled
				expandIcon={<Icon name="expand-more-filled" />}
				aria-controls={`panel${title}-content`}
				id={`panel${title}-header`}>
				<Typography variant="body1">{title}</Typography>
			</AccordionSummaryStyled>
			<AccordionDetails>{children}</AccordionDetails>
		</AccordionStyled>
	);
}
